import { Component, ElementRef } from '@angular/core';

import { ScheduleSelectorService } from 'src/app/schedules/services/schedule-selector.service';

import { ComponentsService } from '../../services/components.service';

@Component({
    selector: 'template-component-schedules',
    templateUrl: './schedules.component.html',
    styleUrls: ['./schedules.component.scss'],
    standalone: false
})
export class SchedulesComponent {

  public componentId: string;

  constructor(private elementRef: ElementRef,
    private componentsFactory: ComponentsService,
    public scheduleSelectorService: ScheduleSelectorService) {

    this.componentsFactory.registerDirective({
      type: 'rise-schedules',
      element: this.elementRef.nativeElement
    });
  }

}
